<template>
    <div v-wechat-title="title" class="padding10">
        <crud-facecade ref="adverse-reactions-list" :url="url" :columns="columnList" :buttons="buttons" :addButton="{ enabled: false }" :updateButton="{ enabled: false }" @loadDocument="loadDocument">
            <slot slot="filter">
                <el-col :md="9" :lg="7" :xl="5">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
                <el-col :md="5" :lg="4" :xl="3">
                    <item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" :clearable="true" placeholder="请选择区域"></item-input>
                </el-col>
            </slot>
        </crud-facecade>
        <el-dialog class="adverse-reactions" title="不良反应" :visible.sync="adverse.dialogFormVisible" :close-on-click-modal="false" width="60%">
            <!-- <el-row>
        <el-col :span="24" class="align-left">
          <span :class="this.adverse_record&&this.adverse_record.id?'el-icon-check':''" class="fg-primary"></span>
          <span class="fg-info padding-left20">记录人：</span>{{this.adverse_record&&this.adverse_record.modifier||'--'}}
          <span class="fg-info padding-left20">记录时间：</span>{{this.adverse_record&&this.adverse_record.modify_date&& this.$moment(this.adverse_record.modify_date).format("YYYY/MM/DD HH:mm:ss")||'--'}}
        </el-col>
      </el-row> -->
            <DocFrame ref="doc" style="height: 580px" :docno="this.$root.DOCUMENT.SX012" :guid="adverse.docguid" :surgeryId="adverse.surgeryId" docname="不良反应记录单"></DocFrame>
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `BloodAdverseReactions`,
    props: {},
    data() {
        return {
            title: `不良反应`,
            o_dic_operating_ward_id: undefined,
            issetoperatingward: false,
            rdate: [
                this.$moment()
                    .add(-7, `days`)
                    .format(`YYYY/MM/DD HH:mm:ss`),
                this.$moment()
                    .add(1, `days`)
                    .format(`YYYY/MM/DD HH:mm:ss`)
            ],
            url: {
                area: `BloodAdverseReactions`,
                baseURL: ``,
                get: () => {
                    return new Promise((resolve, reject) => {
                        let that = this
                        let req = that.myaxios.get(`/api/Nursing/AdverseReaction/GetByDate`, { from: this.rdate[0], to: this.rdate[1] })
                        req.then(data => {
                            if (that.dic_operating_ward_id) {
                                data = _.filter(data, { dic_operating_ward_id: that.dic_operating_ward_id })
                            }
                            let r = data.map(d => {
                                d.use_blood_type = `${d.blood_type || `--`}(${d.blood_type_rh || `--`})`
                                return d
                            })
                            resolve(r)
                        }).catch(e => reject(e))
                    })
                }
            },
            buttons: [
                {
                    class: `is-plain`,
                    label: `查看`,
                    icon: ``,
                    type: `primary`,
                    emit: `loadDocument`,
                    permission: `default`
                }
            ],
            adverse: {
                dialogFormVisible: false,
                docguid: ``,
                surgeryId: undefined
            },
            adverse_record: {}
        }
    },
    mounted() {
        this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
    },
    computed: {
        ...mapGetters([`sys_enums`, `operation_ward_auth`, `active_ward`]),
        dic_operating_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `id`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `姓名`,
                    isListable: true,
                    colspan: 4
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`blood_ddverse_reactions.visit_no`),
                    isListable: true,
                    colspan: 4
                },
                {
                    type: `string`,
                    prop: `use_blood_type`,
                    label: `病人血型`,
                    isListable: true,
                    colspan: 4
                },
                {
                    type: `string`,
                    prop: `dic_operating_ward`,
                    label: `手术区 `,
                    isListable: true,
                    colspan: 4
                },
                {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `手术间`,
                    isListable: true,
                    colspan: 4
                },
                {
                    type: `string`,
                    prop: `anesthesiologist`,
                    label: this.T(`medical_record.plan_anes_doctor`),
                    isListable: true,
                    colspan: 3
                },
                {
                    type: `datetime`,
                    prop: `modify_date`,
                    label: `不良反应发生时间`,
                    isListable: true,
                    sortable: `desc`,
                    colspan: 3
                },
                {
                    type: `string`,
                    prop: `modifier`,
                    label: `记录人`,
                    isListable: true,
                    colspan: 3
                }
            ]
        }
    },
    methods: {
        loadDocument({ row }) {
            this.adverse_record = row
            this.adverse = {
                dialogFormVisible: true,
                docguid: row.document_id,
                surgeryId: row.biz_surgery_info_id
            }
            this.$nextTick(() => {
                this.$refs.doc.loadDocument()
            })
        }
    },
    watch: {
        rdate: function() {
            this.$refs[`adverse-reactions-list`].ReloadListData()
        },
        dic_operating_ward_id: function() {
            this.$refs[`adverse-reactions-list`].ReloadListData()
        }
    }
}
</script>
<style  lang="less">
.adverse-reactions .el-dialog__body {
    padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Blood/AdverseReactions.vue